// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3xeVl","inputWrap":"CustomTip_inputWrap__2JMrU"};